import React, { useState, useEffect } from "react";
// import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import TableSkeleton from "../../StyledComponents/TableSkeleton";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import "../Invoices/NewInvoice/Tables/style.css";
import EmptyData from "../../StyledComponents/Table/EmptyData";
// import { downloadInvoicesAttachmentMergedPDF } from "./actions";

import { downloadInvoicesAttachmentMergedPDF } from "../Home/actions";
const useStyles = makeStyles({
  iconButton: {
    visibility: "hidden",
    fontSize: "14px",
  },
  tableCell: {
    position: "relative",
    cursor: "pointer",
    "&:hover  $iconButton": {
      visibility: "visible",
    },
  },
  iconButtonActive: {
    position: "absolute",
    top: "50%",
    fontSize: "14px",
    transform: "translateY(-50%)",
    visibility: "visible",
    cursor: "pointer",
  },
  table: {
    // width: 0,
    minWidth: "100%",
    
  },
  inputStyle: {
    outline: "none",
    border: "none",
    background: "transparent",
  },
  inputHov: {
    cursor: "pointer",
    color: "blue",
    textDecoration: "underline",
  },
  tabCon: {
      width: "max-content !important",
      textAlign: "center",
  },
  
});

const InvoiceTableChangeUser = ({
  invoiceList,
  loading,
  invoiceAction,
  formState,
  setFormState,
//   visitedInvoices,
  setErrAlertMessage,
  setExcelInvoiceListData,
  setisOrderUpdated,
  setInvoicesList, 
  invoicesList ,
  
}) => {
  const classes = useStyles();
  const [headers, setHeaders] = useState({});
  // Avoid a layout jump when reaching the last page with empty rows.
  // const emptyRows =
  // page > 0 ? Math.max(0, (1 + page) * rowsPerPage - invoiceList.length) : 0;
  const [isSelectedAllInvoices, setIsSelectedAllInvoices] = useState(false);
 
  const [downloadAttachmentLoading, setDownloadAttachmentLoading] =
    useState(false);

  const addInvoiceInList = (id) => {
    const invoiceId = Number(id);
    setInvoicesList((invoicesList) => [...invoicesList, invoiceId]);
    setExcelInvoiceListData((invoicesList) => [...invoicesList, invoiceId]);
  };
  const removeInvoiceFromList = (id) => {
    const invoiceId = Number(id);
    const filteredInvoices = invoicesList?.filter((i) => i !== invoiceId);
    setInvoicesList(filteredInvoices);
    setExcelInvoiceListData(filteredInvoices);
  };

  const removeAllInvoiceFromList = () => {
    setInvoicesList([]);
    setExcelInvoiceListData([]);
  };
  const addAllInvoiceInList = () => {
    const invoices = [];
    for (let index = 0; index < invoiceList.length; index++) {
      const element = invoiceList[index];
      invoices.push(Number(element?.Invoice_Id));
    }
    setInvoicesList(invoices);
    setExcelInvoiceListData(invoices);
  };

  const downloadInvoicesAttachment = () => {
    downloadInvoicesAttachmentMergedPDF(
      invoicesList,
      setDownloadAttachmentLoading,
      setErrAlertMessage
    );
  };

  useEffect(()=>{
    if(invoiceList?.length > 0){
      if(invoicesList?.length === invoiceList?.length) {
        setIsSelectedAllInvoices(true)
      }
      else {
        setIsSelectedAllInvoices(false)
      }
    }
  },[invoicesList])

  useEffect(() => {
    if (invoiceList.length > 0) {
      let obj = {};
      const object = invoiceList[0];
      for (const property in object) {
        const name = property.replace(/\s/g, "");
        obj[name] = property;
      }

      setHeaders(obj);
      // invoiceList.map((x, i, k) => {
      //
      //
      // });
    }
  }, [invoiceList]);

  const Sorting = (value) => {
    setisOrderUpdated(false)
    setFormState((formState) => ({
      ...formState,
      OrderBy: value,
    }));
  };

  const isAscending = (value) => {
    setFormState((formState) => ({
      ...formState,
      isAsc: value,
    }));
  };

  return (
    <Grid container style={{ margin: "20px 0px", overflowY: "auto" }}>
            <Grid item xs={12} sm={12} md={12} lg={12} mt={0} style={{ width: "0" }}>

            {Object.keys(headers).length !== 0 && (
        <TableContainer
          className={`${classes.tabCon} `}
          
        >
          <Table className={classes.table}         size="small"  >
            <TableHead style={{ position: "sticky", top: -2, zIndex: "1" }}>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30"  }}>
                  <Checkbox
                    color="secondary"
                    fontSize="small"
                    // style={{
                    //   color: "#ff9d5c",
                    // }}
                    checked={isSelectedAllInvoices}
                    name="IsDifferentVendor"
                    onChange={(event) => {
                      setIsSelectedAllInvoices(event.target.checked);
                      event.target.checked
                        ? addAllInvoiceInList()
                        : removeAllInvoiceFromList();
                    }}
                  />
                </TableCell>
                {headers.InvoiceNo && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      setFormState(() => ({
                        ...formState,
                        // OrderBy: "invoice_id",
                        isAsc: !formState?.isAsc,
                      }));
                      Sorting(headers.InvoiceNo);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.InvoiceNo}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.InvoiceNo
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.InvoiceNo
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.VendorCode && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.VendorCode);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.VendorCode}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.VendorCode
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.VendorCode
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}

                {headers.VendorName && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.VendorName);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.VendorName}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.VendorName
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.VendorName
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}

                {headers.InvoiceType && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.InvoiceType);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.InvoiceType}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${
                            formState.OrderBy === headers.InvoiceType
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${
                            formState.OrderBy === headers.InvoiceType
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}

                {/* {headers.PONumber && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.PONumber);
                    }}
                  >
                    <span className={classes.tableCell}>
                      {headers.PONumber}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.PONumber
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.PONumber
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )} */}

                {headers.DueDate && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.DueDate);
                    }}
                    align="center"
                  >

                    <span className={classes.tableCell}>
                      {headers.DueDate}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.DueDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.DueDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.InvoiceDate && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.InvoiceDate);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.InvoiceDate}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.InvoiceDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.InvoiceDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}

                {headers.SubmissionDate && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.SubmissionDate);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.SubmissionDate}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.SubmissionDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.SubmissionDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.SubmittedBy && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.SubmittedBy);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.SubmittedBy}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.SubmittedBy
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.SubmittedBy
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.IPUser && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.IPUser);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.IPUser}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.IPUser
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.IPUser
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.InvoiceAmount && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.InvoiceAmount);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.InvoiceAmount}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.InvoiceAmount
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.InvoiceAmount
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}

                {invoiceList?.[0]?.["PO/None PO"] ? (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(invoiceList?.[0]?.["PO/None PO"]);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {invoiceList?.[0]?.["PO/None PO"]}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy ===
                            invoiceList?.[0]?.["PO/None PO"]
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy ===
                            invoiceList?.[0]?.["PO/None PO"]
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                ) : (
                  ""
                )}

                {headers.DaysToSaleTaxLaps && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.DaysToSaleTaxLaps);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.DaysToSaleTaxLaps}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.DaysToSaleTaxLaps
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.DaysToSaleTaxLaps
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {/*  {headers.BarcodeNo && (
              <TableCell style={{ fontWeight: "bold", color: "#031C30" }} onClick={()=>{isAscending(!formState?.isAsc); Sorting(headers.BarcodeNo)}}>
                <span className={classes.tableCell}>{headers.BarcodeNo} {formState.isAsc ?
                    <ArrowUpwardIcon 
                    // onClick={() => isAscending(false)} 
                    className={`${formState.OrderBy === headers.BarcodeNo ? classes.iconButtonActive : classes.iconButton}`} />
                    :
                    <ArrowDownwardIcon 
                    // onClick={() => isAscending(true)}
                     className={`${formState.OrderBy === headers.BarcodeNo ? classes.iconButtonActive : classes.iconButton}`} />}
              </TableCell>
          )}*/}
                {headers.Status && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.Status);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.Status}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.Status
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.Status
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.PendingWith && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.PendingWith);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.PendingWith}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.PendingWith
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.PendingWith
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.ReturnDate && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.ReturnDate);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {" "}
                      {headers.ReturnDate}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.ReturnDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.ReturnDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.ActionBy && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.ActionBy);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.ActionBy}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.ActionBy
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.ActionBy
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.PostingDate && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.PostingDate);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.PostingDate}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.PostingDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.PostingDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.InvoiceDescription && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.InvoiceDescription);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.InvoiceDescription}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.InvoiceDescription
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.InvoiceDescription
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.DocumentNumber && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.DocumentNumber);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.DocumentNumber}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.DocumentNumber
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.DocumentNumber
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.WTIT && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.WTIT);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.WTIT}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.WTIT
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.WTIT
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.STIT && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.STIT);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.STIT}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.STIT
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.STIT
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
                {headers.ProcessedDate && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.ProcessedDate);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.ProcessedDate}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.ProcessedDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.ProcessedDate
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}

                {headers.PSID && (
                  <TableCell
                    style={{ fontWeight: "bold", color: "#031C30" }}
                    onClick={() => {
                      isAscending(!formState?.isAsc);
                      Sorting(headers.PSID);
                    }}
                    align="center"
                  >
                    <span className={classes.tableCell}>
                      {headers.PSID}{" "}
                      {formState.isAsc ? (
                        <ArrowUpwardIcon
                          // onClick={() => isAscending(false)}
                          className={`${formState.OrderBy === headers.PSID
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          // onClick={() => isAscending(true)}
                          className={`${formState.OrderBy === headers.PSID
                              ? classes.iconButtonActive
                              : classes.iconButton
                          }`}
                        />
                      )}
                    </span>
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            {loading && (
              <TableSkeleton
                style={{ width: "100%" }}
                noOfColumns={10}
                noOfLines={5}
                flag={true}
              />
            )}
            <TableBody>
              {invoiceList?.length > 0 &&
                invoiceList.map((item, index) => {

                  const a = invoicesList.find(
                    (x) => x === Number(item.Invoice_Id)
                  );
                  const isChecked = a ? true : false;

                  // Parse the input date using moment
                  const isFormattedDueDate = moment(
                    item?.["Due Date"],
                    ["MMM D YYYY h:mma", "MMM DD YYYY h:mma"],
                    true
                  ).isValid();
                  const isFormattedPostDate = moment(
                    item?.["Posting Date"]?.replace(/\s+/g, " "),
                    ["MMM D YYYY h:mma", "MMM DD YYYY h:mma"],
                    true
                  ).isValid();
                  // Format the date in the desired output format
                  const formattedDueDate = item?.["Due Date"]
                    ? isFormattedDueDate
                      ? moment(item?.["Due Date"]?.replace(/\s+/g, " "), [
                          "MMM D YYYY h:mma",
                          "MMM DD YYYY h:mma",
                        ]).format("DD-MMM-YYYY")
                      : moment(item?.["Due Date"]).format("DD-MMM-YYYY")
                    : "";
                  const formattedPostingDate = item?.["Posting Date"]
                    ? isFormattedPostDate
                      ? moment(item?.["Posting Date"], [
                          "MMM D YYYY h:mma",
                          "MMM DD YYYY h:mma",
                        ]).format("DD-MMM-YYYY")
                      : moment(item?.["Posting Date"]).format("DD-MMM-YYYY")
                    : "";

                  // Format the date in the desired output format

                  return (
                    <TableRow
                      sx={{
                        backgroundColor:
                          (item.Urgent == "True" && "#FFCCCB") ||
                          (item.SkipTaxStep == "True" && "#3799") ||
                          (item.IsVFPayment == "True" &&
                            "rgb(7, 177, 111, 0.48)") ||
                          (item.IsVPPayment == "True" && "#ff9d5c"),
                      }}
                    >
                      <TableCell style={{ textAlign: "center" }}>
                        <Checkbox
                          color="secondary"
                          fontSize="small"
                          checked={isChecked}
                          name="IsDifferentVendor"
                          onChange={(event) => {
                            
                            setIsSelectedAllInvoices(false);

                            event.target.checked
                              ? addInvoiceInList(item?.Invoice_Id)
                              : removeInvoiceFromList(item?.Invoice_Id);
                          }}
                        />
                      </TableCell>
                      <TableCell onClick={() => invoiceAction(item)} align="center">
                        <u
                        //   style={{
                        //     color: visitedInvoices.includes(item["Invoice No"])
                        //       ? "black"
                        //       : "blue",
                        //     cursor: "pointer",
                        //   }}
                        >
                          {item["Invoice No"]}
                        </u>
                      </TableCell>
                      {headers.VendorCode && (
                        <TableCell align="center">
                          {item?.["Vendor Code"]}
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["Vendor Code"]}
                        className={classes.inputStyle}
                      /> */}
                        </TableCell>
                      )}
                      {headers.VendorName && (
                        <TableCell align="center">
                          {item?.["Vendor Name"]}
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["Vendor Name"]}
                        className={classes.inputStyle}
                      /> */}
                          {/* {item?.["Vendor Name"]}  */}
                        </TableCell>
                      )}

                      {headers.InvoiceType && (
                        <TableCell align="center">
                          {item?.["Invoice Type"]}
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["Vendor Name"]}
                        className={classes.inputStyle}
                      /> */}
                          {/* {item?.["Vendor Name"]}  */}
                        </TableCell>
                      )}
                      {/* {headers.PONumber && (
                        <TableCell>
                          <input
                        style={{ color: '#888888' }}
                        value={item?.["PO Number"]}
                        className={classes.inputStyle}
                      />
                          {item?.["PO Number"]}
                        </TableCell>
                      )} */}

                      {headers.DueDate && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={moment(item?.["Due Date"]).format("DD-MMM-YYYY")}
                        className={classes.inputStyle}
                      /> */}
                          {/* {moment(item?.["Due Date"]).format("DD-MMM-YYYY")} */}
                          {formattedDueDate}
                        </TableCell>
                      )}
                      {headers.InvoiceDate && (
                        <TableCell align="center">
                          {/* <input

                        style={{ color: '#888888' }}
                        value={moment(item?.["Invoice Date"]).format(
                          "DD-MMM-YYYY"
                        )}
                        className={classes.inputStyle}
                      /> */}
                          {moment(item?.["Invoice Date"]).format("DD-MMM-YYYY")}
                        </TableCell>
                      )}

                      {headers.SubmissionDate && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={moment(item?.["Submission Date"]).format(
                          "DD-MMM-YYYY"
                        )}
                        className={classes.inputStyle}
                      /> */}
                          {moment(item?.["Submission Date"]).format(
                            "DD-MMM-YYYY"
                          )}
                        </TableCell>
                      )}

                      {headers.SubmittedBy && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["Submitted By"]}
                        className={classes.inputStyle}
                      /> */}
                          {item?.["Submitted By"]}
                        </TableCell>
                      )}
                      {headers.IPUser && (
                        <TableCell>{item?.["IP User"]}</TableCell>
                      )}
                      {headers.InvoiceAmount && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["Invoice Amount"]}
                        className={classes.inputStyle}
                      /> */}
                          {(Number(item?.["Invoice Amount"]))?.toLocaleString()}
                        </TableCell>
                      )}
                      {invoiceList?.[0]?.["PO/None PO"] && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["PO/None PO"]}
                        className={classes.inputStyle}
                      /> */}
                          {item?.["PO/None PO"]}
                        </TableCell>
                      )}
                      {headers.DaysToSaleTaxLaps && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["Days To Sale Tax Laps"]}
                        className={classes.inputStyle}
                      /> */}
                          {item?.["Days To Sale Tax Laps"]}
                        </TableCell>
                      )}
                      {/*
                  {headers.BarcodeNo && (
                    <TableCell>
                      <input
                      // style={{color:'#888888' }}
                        value={item?.["Barcode No"]}
                        className={classes.inputStyle}
                      />
                    </TableCell>
                  )}
                
                */}
                      {headers.Status && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["Status"]}
                        className={classes.inputStyle}
                      /> */}
                          {item?.["Status"]}
                        </TableCell>
                      )}
                      {headers.PendingWith && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["Pending With"]}
                        className={classes.inputStyle}
                      /> */}
                          {item?.["Pending With"] || item?.["PendingWith"]}
                        </TableCell>
                      )}

                      {headers.ReturnDate && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={moment(item?.["Return Date"]).format(
                          "DD-MMM-YYYY"
                        )}
                        className={classes.inputStyle}
                      /> */}
                          {item?.["Return Date"]
                            ? moment(item?.["Return Date"]).format(
                                "DD-MMM-YYYY"
                              )
                            : ""}
                        </TableCell>
                      )}
                      {headers.ActionBy && (
                        <TableCell align="center">
                          <input
                            style={{ color: "#888888" }}
                            value={item?.["Action By"]}
                            className={classes.inputStyle}
                          />
                        </TableCell>
                      )}
                      {headers.PostingDate && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={moment(item?.["Posting Date"]).format(
                          "DD-MMM-YYYY"
                        )}
                        className={classes.inputStyle}
                      /> */}
                          {/* {moment(item?.["Posting Date"]).format("DD-MMM-YYYY")} */}
                          {formattedPostingDate}
                        </TableCell>
                      )}
                      {headers.InvoiceDescription && (
                              <TableCell>
                                {item?.["Invoice Description"]}
                              </TableCell>
                      )}
                      {headers.DocumentNumber && (
                        <TableCell align="center">
                          {/* <input
                        style={{ color: '#888888' }}
                        value={item?.["Document Number"]}
                        className={classes.inputStyle}
                      /> */}
                          {item?.["Document Number"]}
                        </TableCell>
                      )}
                      {headers.WTIT && <TableCell align="center">{item?.["WTIT"]}</TableCell>}
                      {headers.STIT && <TableCell align="center">{item?.["STIT"]}</TableCell>}
                      {headers.ProcessedDate && (
                        <TableCell align="center">
                          {moment(item?.["Processed Date"]).format(
                            "DD-MMM-YYYY"
                          )}
                        </TableCell>
                      )}
                      {headers.PSID && <TableCell>{item?.["PSID"]}</TableCell>}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer >
      )}
      {invoiceList?.length === 0 && !loading ? <EmptyData /> : ""}
      {
        Object.keys(headers).length === 0 && loading ? (
        <TableSkeleton
          style={{ width: "100%" }}
          noOfColumns={10}
          noOfLines={5}
          flag={true}
        />
      ) : (
        ""
      )
    }
              </Grid>
              </Grid>
  );
};

export default InvoiceTableChangeUser;
